"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionButton_1 = require("../ActionButton/ActionButton");
/**
 * {@docCategory Button}
 */
exports.CommandButton = ActionButton_1.ActionButton;
//# sourceMappingURL=CommandButton.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Button/CommandButton/CommandButton.js
// module id = 737
// module chunks = 0